// Auto-generated from finance Google Sheet (Feb 2026).
// Source: https://docs.google.com/spreadsheets/d/1cHBT6_HX_QTAqm_FdoMpTFTuAYdIrPYhEmqSjNEPZEk/
// Amounts in ₹ Cr. Maintained manually by Finance.

export const AWP_DATA_FY_24_25 = [
  { theme: "Rural Upliftment",           projected: 107.0, utilisation: 130.0 },
  { theme: "Education",                  projected: 206.0, utilisation: 227.0 },
  { theme: "Healthcare",                 projected:  79.0, utilisation:  75.0 },
  { theme: "Water and Sanitation",       projected:  48.0, utilisation:  38.0 },
  { theme: "Nutrition",                  projected:  51.0, utilisation:  35.0 },
  { theme: "Urban Poverty Alleviation",  projected:  23.0, utilisation:  10.0 },
  { theme: "Arts",                       projected:  13.0, utilisation:  28.0 },
  { theme: "Institutions & Others",      projected: 168.0, utilisation:  95.0 },
  { theme: "Cancer Care",                projected: 123.0, utilisation: 109.0 },
  { theme: "Discretionary",              projected:  32.0, utilisation:  22.0 },
];

export const AWP_DATA_FY_25_26 = [
  { theme: "Rural Upliftment",           projected: 165.40, utilisation: 199.44 },
  { theme: "Education",                  projected: 227.00, utilisation: 252.31 },
  { theme: "Healthcare",                 projected: 122.51, utilisation: 102.74 },
  { theme: "Water and Sanitation",       projected:  51.69, utilisation:  59.37 },
  { theme: "Nutrition",                  projected:  52.27, utilisation:  57.64 },
  { theme: "Urban Poverty Alleviation",  projected:  28.07, utilisation:  35.39 },
  { theme: "Arts",                       projected:  20.18, utilisation:  19.17 },
  { theme: "Institutions & Others",      projected: 134.35, utilisation: 111.39 },
  { theme: "Cancer Care",                projected: 251.99, utilisation: 207.57 },
  { theme: "Discretionary",              projected: 100.00, utilisation:  88.10 },
  { theme: "Other (The AI 171 Memorial and Welfare Trust)", projected: 250.00, utilisation: 250.00 },
];

// FY 2026-27 — Budget estimates from Finance sheet (Jul 2026).
// Per stakeholder: fold Discretionary (₹117 Cr) + IGP–Education & Medical (₹261 Cr)
// into a single "Others" bucket → ₹378 Cr.
export const AWP_DATA_FY_26_27 = [
  { theme: "Rural Upliftment",           projected: 265.0, utilisation: 265.0 },
  { theme: "Education",                  projected: 212.0, utilisation: 212.0 },
  { theme: "Healthcare",                 projected: 288.0, utilisation: 288.0 },
  { theme: "Water and Sanitation",       projected: 101.0, utilisation: 101.0 },
  { theme: "Nutrition",                  projected: 104.0, utilisation: 104.0 },
  { theme: "Urban Poverty Alleviation",  projected:  62.0, utilisation:  62.0 },
  { theme: "Arts",                       projected:  30.0, utilisation:  30.0 },
  { theme: "Institutions & Others",      projected: 103.0, utilisation: 103.0 },
  { theme: "Cancer Care",                projected: 308.0, utilisation: 308.0 },
  { theme: "Others",                     projected: 378.0, utilisation: 378.0 },
];

/**
 * Returns the AWP dataset for the supplied FY filter value.
 * @param {string|string[]|undefined} fy - Selected FY filter (single string or array)
 * @returns {Array|null} rows for the selected FY, or null if not exactly one supported FY.
 */
export function getAwpDataForFy(fy) {
  const list = Array.isArray(fy) ? fy : (fy ? [fy] : []);
  if (list.length !== 1) return null;
  const v = list[0];
  if (v === "FY 2024-25") return AWP_DATA_FY_24_25;
  if (v === "FY 2025-26") return AWP_DATA_FY_25_26;
  if (v === "FY 2026-27") return AWP_DATA_FY_26_27;
  return null;
}

// Back-compat default export (used by Raw Data page) – defaults to FY 24-25 set.
export const AWP_DATA = AWP_DATA_FY_24_25;
